export const TRIAL_QUERY = '/trial';
